<app-topbar></app-topbar>
<main class="layout-container" style="flex: 1; display: flex; flex-direction: column">
  <div class="md:mx-8 mx-2">
    <p class="text-900 text-3xl font-medium mb-3">Cadastrar Grupo de Permissões</p>
  </div>
  <p-card class="mx-2 md:mx-8 mb-5">
    <form class="font-semibold" [formGroup]="grupoAcessoForm" (ngSubmit)="salvarGrupoAcesso()">
      <div class="mx-2 field">
        <label for="nome">Nome do Grupo <span class="text-red-500">*</span></label>
        <input placeholder="Nome do Grupo" pInputText required formControlName="nome" />
      </div>
      
      <div class="mx-2 field">
        <label for="nome">Descrição <span class="text-red-500">*</span></label>
        <input placeholder="Descrição" pInputText required formControlName="descricao" />
      </div>

      <div class="mx-2 mt-4 field mb-4">
        <label for="status" class="font-normal">Status da Descrição <span class="text-red-500">*</span></label>
        <div class="flex flex-wrap gap-3">
          <div class="flex align-items-center">
            <p-radioButton name="status" value="A" formControlName="status" inputId="ativo" />
            <label for="ativo" class="ml-2">Ativo</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="status" value="I" formControlName="status" inputId="inativo" />
            <label for="inativo" class="ml-2">Inativo</label>
          </div>
        </div>
      </div>
      <div class="mx-2 mt-3 flex gap-2 mb-3">
        <p-button pRipple type="submit" label="Salvar"></p-button>
        <p-button pRipple severity="secondary" label="limpar"></p-button>
      </div>

    </form>
  </p-card>

  <p-card class="md:mx-8 mx-2">
      <p-table [value]="grupoAcesso" class="mt-5 p-datatable-gridlines p-datatable-striped" responsiveLayout="stack">
        <ng-template pTemplate="caption">Grupos Cadastrados</ng-template>
        <ng-template pTemplate="header">
          <tr>
            
            <th pSortableColumn="grupo_id" class="text-center">Id <p-sortIcon field="grupo_id"></p-sortIcon></th>
            <th pSortableColumn="grupo_nome" class="text-center">Nome <p-sortIcon field="grupo_nome"></p-sortIcon></th>
            <th pSortableColumn="grupo_descricao" class="text-center">Descrição <p-sortIcon field="grupo_descricao"></p-sortIcon></th>
            <th pSortableColumn="grupo_status" class="text-center">Status <p-sortIcon field="grupo_status"></p-sortIcon></th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-grup>
          <tr>
            <td><span class="p-column-title">
              Id</span>{{ grup.grupo_id }}
            </td>
            <td><span class="p-column-title">
              Nome</span>{{ grup.grupo_nome }}
            </td>
            <td class="text-center">
              <span class="p-column-title">
              Descrição</span>{{ grup.grupo_descricao }}
            </td>
            <td class="text-center">
              <span class="p-column-title">Status</span>{{ grup.grupo_status }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
</main>
